module.exports = __webpack_public_path__ + "img/vale-a-pena.svg";